import { useCallback } from "react";
import { useNotify } from "react-admin";
import { errorMessages } from "app";

// Резолва бекенд грешка до съобщение на български:
// error.message → errorMessages[error.errorCode] → errorMessages.default
export const resolveErrorMessage = error =>
  error?.message || errorMessages[error?.errorCode] || errorMessages.default;

// Hook, който връща готов нотификатор за грешки.
// Референцията е стабилна (useCallback), за да може безопасно да влиза в useEffect deps.
// Употреба:
//   const notifyError = useNotifyError();
//   try { ... } catch (error) { notifyError(error); }
export const useNotifyError = () => {
  const notify = useNotify();
  return useCallback(
    (error, options) => notify(resolveErrorMessage(error), { type: "error", ...options }),
    [notify],
  );
};
